<template>
  <div>
    <header>
          <div class="headerOne">
                <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)">   -->
          </div>
            <span class="myOne">我的个人信息</span>
    </header>
    <div class="ulOne">
        <ul>
            <li class="other"  v-for="(item,index) in vipArry" :key="index">
                <span class="nameOne">{{item.vipName}}</span>
                <div class="topOne">享受{{item.zheKou/10}}折,{{item.other}}</div>
            </li>
            <!-- <li>
                <span class="nameOne">VIP2特权</span>
                <div class="topOne">消费满100元结算享受7折充值1元=10积分,可参加店内其他优惠活动</div> 
            </li> -->
        </ul>
    </div>
  </div>


</template>
<script>
import axios from "axios";
    export default{
        data(){
            return{
                vipArry:this.$route.query.vipArry
            }
        },
        created(){
            console.log(this.vipArry)
        }
    }
</script>
<style scoped>
.other .nameOne{
    font-size: 0.55rem !important
}
.topOne{
    font-size: 0.55rem !important
}
.el-icon-arrow-left{
    font-size: 0.8rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header{
    height:1.6rem;
    width: 100%;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    background: white
}
 .headerOne{
     font-size: 0;  
     width: 20%;
     
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem;
    
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .topOne{}
  .myOne{
      font-size: 0.55rem;
      position: absolute;
      top: 0.42rem;
      left:3.5rem;
      }
    .ulOne{
           width: 90%;
           margin: 0 auto;
           margin-bottom: 0.65rem;
       }
.ulOne ul li{
 font-size: 0.45rem;
 margin: 0.28rem 0.4rem 0.3rem 0;
    position: relative;
    color: #333333;
}
.ulOne ul li .nameTo{
    color: rgba(0,0,0,0.5);
    margin-left: 0.3rem
}
.nameOne{
    vertical-align: top;
    margin-right: 0.25rem;
 
}
.nameOld span{
display: block;
width: 5rem
}
.nameOld :last-child{
display: block;
width: 5rem;
color: pink;
padding-top: 0.25rem
}
.ulOne ul li div{
    display: inline-block;
    color: rgba(0,0,0,0.5);
    width:4.3rem;
}    
</style>



// WEBPACK FOOTER //
// src/components/change/alldeil.vue